var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.baseClass},[_vm._l((['name', 'path']),function(col){return _c('div',{key:col,class:`${_vm.baseClass}__column mb-2`},[_c('h4',[_vm._v(_vm._s(_vm.$t(`${_vm.pre}.${col}`)))])])}),_c('div',{class:`${_vm.baseClass}__actions`})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }